define('services/events/user-events',[
    // libs
    'underscore', 'utils',
    // parent
    'src/event-aggregator'
], function(_, U, EventAggregator) {

    var UserEvents = _.extend({}, EventAggregator.prototype, {
        profileUpdate: function(model, opt) {
            opt = opt || {};
            this.trigger('profile:update', model, opt);
        },

        editMemberFromProfile: function(model, e) {
            this.trigger('profile:editFromProfile', model, e);
        },

        editGroup: function(model, e) {
            this.trigger('group:editGroup', model, e);
        },

        groupModify: function(model) {
            this.trigger('group:modify', model);
        },

        groupManage: function() {
            this.trigger('group:manage');
        },

        fetchComplete: function() {
            this.trigger('profile:fetchComplete');
        },

        newMemberAdded: function(model) {
            this.trigger('member:added', model);
        },

        closingEditSettingPanel: function() {
            this.trigger('member:closingEditSettingPanel');
        },

        getMemberFullList: function() {
            this.trigger('member:getMemberFullList');
        },

        sendMemberFullList: function(memberList) {
            this.trigger('member:sendMemberFullList', memberList);
        },

        switchMode: function() {
            this.trigger('switchMode');
        },

        onAddClientClick: function() {
            this.trigger('onAddClientClick');
        },

        testUserAdded: function (user, redirect) {
            this.trigger('testUserAdded', user, redirect);
        },

        createMeetingClick: function() {
            this.trigger('createMeetingClick');
        },

        refreshCompletedTutorialsCount: function() {
            this.trigger('refreshCompletedTutorialsCount');
        },

        zoomUpdated: function() {
            this.trigger('zoomUpdated');
        }
    });
    return UserEvents;
});

